import { Moment } from 'moment';

export enum TimePeriod {
  day = 'day',
  week = 'week',
  month = 'month',
  year = 'year',
}

export type PeriodFilter<T extends Moment | string> = {
  from: T;
  until: T;
  unit: TimePeriod;
  websiteId: string;
};

export type DateRangeKey =
  | 'today'
  | 'yesterday'
  | 'last7Days'
  | 'last30Days'
  | 'last40Days'
  | 'thisMonth'
  | 'lastMonth'
  | 'prev6Month'
  | 'prev12Month'
  | 'thisYear'
  | 'lastYear'
  | 'allTime';

export type DatePickerShortcut = {
  key: DateRangeKey;
  transKey: string;
  diff?: number;
  isDefault?: boolean;
};
